import { IFollowUpSurvey } from '@nkr/models/follow-up';
import { Panel, Table } from 'react-bootstrap';
import styled from 'styled-components';

const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }

    .label {
        font-size: 100%;
    }
`;

interface IProps {
    data: IFollowUpSurvey
}

const ReviewStatus = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Follow-Up Review Status</Panel.Heading>
            <Panel.Body>
                <TableWrapper striped>
                    <thead>
                        <tr>
                            <th>Review</th>
                            <th>Reviewed By</th>
                            <th>Reporter</th>
                            <th>Reported</th>
                            <th>Status</th>
                            <th>Donor<br />Notified</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Survey</td>
                            <td>{props.data.reviewedByContactName}</td>
                            <td>{props.data.reviewedByUserName}</td>
                            <td>{props.data.reviewedDateTime}</td>
                            <td>n/a</td>
                            <td>n/a</td>
                        </tr>
                        {props.data.areLabResultsGood && (
                            <tr>
                                <td>Labs</td>
                                <td>{props.data.labResultsReviewedByContactName}</td>
                                <td>{props.data.labResultsReviewedByUsername}</td>
                                <td>{props.data.labResultsReviewedDateTime}</td>
                                <td>{props.data.areLabResultsGood ? <span className='label label-success'>normal</span> : <span className='label label-danger'>abnormal</span>}</td>
                                <td>{props.data.isNotifiedOfLabResults ? <span className='label label-success'>yes</span> : <span className='label label-danger'>no</span>}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    )
}

export default ReviewStatus;